// Module
var code = `<a
  class="breadcrumb-link font-lusitana mb-4 text-xl md:text-2xl"
  data-channel="ROUTE"
  data-event-prevent-default="true"
  data-page-id="{{pageId}}"
  data-text="{{title}}"
  data-end-route="true"
  href="{{href}}"
  >{{title}}</a
>
`;
// Exports
module.exports = code;